// extracted by mini-css-extract-plugin
module.exports = {"modalHeaderTitle":"styles_modalHeaderTitle__1rpcR","heading3":"styles_heading3__3FXVu","parent":"styles_parent__1K-sH","text":"styles_text__3VMM4"};